module.exports = __webpack_public_path__ + "img/1951.3925ba2a.svg";